
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import Carousel from 'react-material-ui-carousel';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

import { useSolutionsContext } from './SolutionsContext';
import SolutionsMobileItem from './SolutionsMobileItem';
import SolutionsMobileCarouselItem from './SolutionsMobileCarouselItem';

import './SolutionsMobile.scss';

const SolutionsMobile = ({ solutions, langcode }) => {
    const { dispatch } = useSolutionsContext();

    const onChangeHandler = (activeSlide) => {
        dispatch({
            type: 'SET_ACTIVE_BOX',
            payload: solutions[activeSlide].field_box_number
        });
    };
    return <div className='solutions-container mobile'>
        <div className='solutions-wrapper'>
            <picture>
                <source srcSet="/images/Fraport_AG_AM_03_2023__AMF3817_klein_MOBILE.webp" />
                <img
                    src="/images/Fraport_AG_AM_03_2023__AMF3817_klein_MOBILE_2.jpg"
                    alt=""
                    title=""
                    loading="lazy"
                />
            </picture>
            {
                solutions.map(solution => {
                    return <SolutionsMobileItem solution={solution} key={uniqueId()} />;
                })
            }
        </div>
        <Carousel
            className='solutionsCarousel'
            autoPlay={true}
            indicators={false}
            navButtonsAlwaysVisible={true}
            changeOnFirstRender
            animation='slide'
            onChange={onChangeHandler}
            navButtonsProps={{
                style: {
                    borderRadius: 0,
                    backgroundColor: '#fff',
                    color: '#05164d',
                    width: '40px',
                    height: '40px',
                },
            }}

            NextIcon={<NavigateNextIcon fontSize='large' />}
            PrevIcon={<NavigateBeforeIcon fontSize='large' />}
        >
            {
                solutions.map(solution => {
                    return <SolutionsMobileCarouselItem solution={solution} langcode={langcode} key={uniqueId()} />;
                })
            }
        </Carousel>
    </div>;
};

export default memo(SolutionsMobile);

SolutionsMobile.propTypes = {
    solutions: PropTypes.arrayOf(PropTypes.any),
    langcode: PropTypes.string
};
